<template>
	<b-pagination
		v-model="currentPage"
		:total-rows="rows"
		:per-page="perPage"
		@change="onPageChange"
		first-number
		last-number
	></b-pagination>
</template>

<script>
export default {
	name: "Pagination",
	props: ["data"],
	data: function () {
		return {
			currentPage: 1,
		};
	},
	watch: {
		currentPage: function () {
			this.currentPage = this.data.pageable.pageNumber + 1;
		},
	},
	methods: {
		onPageChange: function (event) {
			this.$emit("page-selected", event);
		},
	},
	computed: {
		rows: function () {
			return this.data.totalElements;
		},
		perPage: function () {
			return this.data.pageable.pageSize;
		},
	},
};
</script>

<style>
</style>